import { api } from 'utility';
import { getCartableDefineDelegationUrl, getUserContactUrl } from 'URLs';

export function transfer(data) {
  return api.post(getCartableDefineDelegationUrl(), data).then((res) => res.data);
}

export function checkContact(data) {
  return api.post(getUserContactUrl(), data).then((res) => res.data);
}

export default {
  checkContact,
  transfer,
};
